import PropTypes from 'prop-types';
import React from 'react';
import { formatNumber } from '../../../shared/formattingUtils';
import { formatGross } from '../utils/format';

const Pagination = ({ pagination, totalGross, loading, onPageChange, isMobile }) => {
  const total = pagination.total_entries || 0;
  const wrapperClass = isMobile ? 'tickets-pagination tickets-pagination--mobile' : 'tickets-pagination';
  return (
    <div className={wrapperClass}>
      <span className="tickets-pagination-summary">
        Showing {formatNumber(total)} event{total === 1 ? '' : 's'}
        {totalGross > 0 && ` · ${formatGross(totalGross)} gross`}
      </span>
      <div className="tickets-pagination-controls">
        <button
          type="button"
          className="btn btn-setlist-secondary btn-sm"
          disabled={loading || pagination.current_page <= 1}
          onClick={() => onPageChange(pagination.current_page - 1)}
        >
          Previous
        </button>
        <span className="tickets-pagination-status">
          Page {formatNumber(pagination.current_page || 1)} of {formatNumber(pagination.total_pages || 1)}
        </span>
        <button
          type="button"
          className="btn btn-setlist-secondary btn-sm"
          disabled={loading || pagination.current_page >= pagination.total_pages}
          onClick={() => onPageChange(pagination.current_page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  pagination: PropTypes.shape({
    current_page: PropTypes.number,
    total_pages: PropTypes.number,
    total_entries: PropTypes.number,
  }).isRequired,
  totalGross: PropTypes.number,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default Pagination;
